import axios from "axios";
import React from "react";
import toastr from "toastr";
import { Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { CustomLoading } from "components/CustomLoading";
import CustomCatEmployeeUsageReport from "./CustomCatEmployeeUsageReport";
import "../../styles/Reports.css";

// Ops-only reports for a policy. Currently hosts the Enhanced Benefits Employee
// Usage Report, which only appears when the policy includes Enhanced Benefits.
// Additional Ops-only policy reports can be added here going forward.
export default class OpsPolicyReports extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            benefitYearOptions: [],
            currentListItem: "Enhanced Benefits Employee Usage Report",
        };

        this.loadData = this.loadData.bind(this);
        this.setCurrentItem = this.setCurrentItem.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        try {
            const benYearRes = await axios.get("/api/PlanAdmin/benefityearsoptions?policyId=" + this.props.policyId);

            let benefitYearOptions = this.state.benefitYearOptions;
            if (benYearRes.data.success) {
                benefitYearOptions = benYearRes.data.benYearOptions || [];
            } else {
                toastr.error(benYearRes.data.message, "Error");
            }

            this.setState({
                benefitYearOptions,
                loading: false,
            });
        } catch (error) {
            this.setState({ loading: false });
            toastr.error("Failed to load Ops policy reports.", "Error");
        }
    };

    setCurrentItem = (item) => {
        this.setState({ currentListItem: item });
    };

    render() {
        if (this.state.loading) {
            return <CustomLoading />;
        }

        let groupedList = {
            "Ops Policy Reports": [],
        };

        if (this.props.hasEnhancedBenefits && this.state.benefitYearOptions.length > 0) {
            groupedList["Ops Policy Reports"].push("Enhanced Benefits Employee Usage Report");
        }

        let tableContents = null;
        if (this.state.currentListItem === "Enhanced Benefits Employee Usage Report") {
            tableContents = (
                <CustomCatEmployeeUsageReport
                    policyId={this.props.policyId}
                    benefitYearOptions={this.state.benefitYearOptions}
                />
            );
        }

        const hasAnyReport = Object.values(groupedList).some((items) => items.length > 0);
        if (!hasAnyReport) {
            return (
                <div style={{ padding: "20px", fontSize: "15px", fontWeight: 500 }}>
                    No Ops policy reports are available for this policy.
                </div>
            );
        }

        return (
            <div className="ktm-reports">
                <Accordion defaultActiveKey="0" className="ktm-reports-sidebar-list">
                    {Object.entries(groupedList)
                        .filter(([_, items]) => items.length > 0)
                        .map(([category, items], groupIndex) => (
                            <Accordion.Item eventKey={groupIndex.toString()} key={category}>
                                <Accordion.Header>{category}</Accordion.Header>
                                <Accordion.Body style={{ padding: "0" }}>
                                    <ul className="list-unstyled mb-0">
                                        {items.map((item) => (
                                            <li key={item}
                                                className="list-group-item"
                                                style={this.state.currentListItem === item ? { backgroundColor: "#848f99", color: "white", cursor: "pointer" } : { cursor: "pointer" }}
                                                onClick={() => this.setCurrentItem(item)}
                                            >
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                </Accordion>
                <Card className="ktm-reports-content">{tableContents}</Card>
            </div>
        );
    }
}
